import type { ChangeSummary } from "@nabla/api";

export interface HeldChange {
  readonly change: ChangeSummary;
  readonly arrivedAt: number;
}

export function createChanges(now: () => number, touch: (topic: string) => void) {
  const changes = new Map<string, HeldChange>();
  return {
    put(change: ChangeSummary): void {
      const held = changes.get(change.id);
      if (held && Date.parse(held.change.updatedAt) > Date.parse(change.updatedAt)) return;
      changes.set(change.id, { change, arrivedAt: now() });
      touch(`change:${change.id}`);
    },
    get: (id: string) => changes.get(id),
    topics: () => [...changes.keys()].map((id) => `change:${id}`),
    clear: () => changes.clear(),
  };
}
